import Result from "@Core/Result";
import { ServiceBase } from "@Core/ServiceBase";
import {IFeedbackTemplateDetails} from "@Models/IFeedbackTemplateDetails";
import {IEntity} from "@Models/IEntity";

const API_URL = "/api/Feedback";

export default class FeedbackService extends ServiceBase {

    /**
     * Create a new template
     * @param groupId
     * @param model
     */
    public async createTemplate(groupId: string, model: IFeedbackTemplateDetails): Promise<Result<IEntity>> {
        return await this.requestJson({
            url: `${API_URL}/CreateTemplate/${groupId}`,
            method: "POST",
            data: model,
        });
    }

    public async getTemplates(groupIds: string[]): Promise<Result<IFeedbackTemplateDetails[]>> {
        return await this.requestJson({
            url: `${API_URL}/GetTemplates/${groupIds}`,
            method: "GET",
        });
    }

    public async updateTemplate(groupId: string, model: IFeedbackTemplateDetails): Promise<Result<boolean>> {
        return await this.requestJson({
            url: `${API_URL}/UpdateTemplate/${groupId}`,
            method: "PATCH",
            data: model,
        });
    }

    public async deleteTemplate(groupId: string, templateId: string): Promise<Result<boolean>> {
        return await this.requestJson({
          url: `${API_URL}/DeleteTemplate/${groupId}?template=${templateId}`,
          method: "DELETE",
        });
    }
}